<template>
  <v-dialog :model-value="dialog" @update:model-value="$emit('update:dialog', $event)" max-width="600px">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h5">Crear una nueva reunión</span>
        <v-btn icon @click="closeWindow">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field v-model="meeting.name" label="Nombre de la reunión" maxlength="40" required></v-text-field>
          <v-textarea v-model="meeting.description" label="Descripción de la reunión" maxlength="500" required></v-textarea>
          
          <v-row>
            <v-col>
              <v-text-field v-model="meeting.fecha" label="Fecha" type="date"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="meeting.horaInicio" label="Hora inicio" type="time"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="meeting.horaFinal" label="Hora fin" type="time"></v-text-field>
            </v-col>
          </v-row>
          
          <v-divider></v-divider>
          
          <!-- Todo: debe agarrar la info del subproyecto si es que corresponde -->
          <v-select
            v-model="selectedInvitados"
            :items="project.userMembers"
            label="Selecciona los invitados"
            multiple
            chips
          ></v-select>
          
          <v-select
            v-model="selectedAnfitrion"
            :items="project.userMembers"
            label="Selecciona el anfitrión"
          ></v-select>
          
          <v-select
            v-model="selectedSecretario"
            :items="project.userMembers"
            label="Selecciona el secretario"
          ></v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="send">Crear reunión</v-btn>
        <v-btn text @click="closeWindow">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Snackbar -->
  <v-snackbar v-model="snackbar.show" :color="snackbar.color" top>
    {{ snackbar.message }}
  </v-snackbar>
</template>

<script>
import api from "@/api";

export default {
  name: "NewMeetingComponent",
  props: {
    dialog: Boolean,
    projectId: {
      type: String,
      required: true,
    },
  },
  computed: {
    // Todo: el proyecto debe ser un prop
    project() {
      return this.$store.state.project || {};
    },
  },
  data() {
    return {
      lastMeeting: {},
      meeting: {
        name: process.env.NODE_ENV === 'development' 
          ? "Reunión de prueba"
          : "",
        description: process.env.NODE_ENV === 'development' 
          ? "Reunión de prueba"
          : "",
        fecha: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        horaInicio: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().substr(11, 5),
        horaFinal: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000 + 60 * 60 * 1000).toISOString().substr(11, 5),
        state: 'new',
      },
      selectedInvitados: [],
      selectedAnfitrion: "",
      selectedSecretario: "",

      // Snackbar
      snackbar: {
        show: false,
        message: '',
        color: 'success',
      },
    };
  },
  methods: {
    closeWindow() {
      this.$emit("update:dialog", false);
    },
    prepareMeetingData() {
      // Preparar lista de invitados
      this.meeting.invitados = this.selectedInvitados;

      // Asignar anfitrión y secretario
      this.meeting.anfitrion = this.selectedAnfitrion;
      this.meeting.secretario = this.selectedSecretario;

      // Asegurarse de que projectId está asignado
      this.meeting.project = this.projectId;
      console.log('projectId que se esta asignando...', this.projectId);
      console.log("ProjectID:", this.meeting.project);

      // Mandar un snackbar si un campo está vacío
      if (
        !this.meeting.description ||
        !this.meeting.fecha ||
        !this.meeting.horaInicio ||
        !this.meeting.horaFinal ||
        !this.meeting.anfitrion ||
        !this.meeting.secretario
      ) {
        this.showSnackbar("Por favor, llena todos los campos", "error");
        return;
      }
    },
    async send() {
      this.prepareMeetingData();
      if (!this.meeting.name || !this.meeting.description || !this.meeting.fecha || !this.meeting.horaInicio || !this.meeting.horaFinal) {
        this.showSnackbar("Por favor, llena todos los campos", "error");
        return;
      }

      // Obtener la cantidad de reuniones del proyecto
      var count = null;
      try {
        const responseCount = await api.get(`/api/meeting/counts/project/${this.projectId}`);
        if ([200, 201].includes(responseCount.status)) {
          count = responseCount.data;
        } else {
          count = -1;
        }
      } catch (error) {
        console.error("Error al enviar la reunión:", error);
        return;
      }

      this.meeting.number = count;

      try {
        const response = await api.post(`/api/meeting`, this.meeting);
        if ([200, 201].includes(response.status)) {
          // Emitir evento de nueva reunión al servidor WebSocket
          this.$socket.emit('event_new_meeting', {
            room: this.$route.params.projectId,
            meeting: response.data,
          });
        } else {
          this.showSnackbar("Error al enviar la reunión", "error");
        }
      } catch (error) {
        console.error("Error al enviar la reunión:", error);
      }

      this.closeWindow();
    },
    showSnackbar(message, color) {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    autoAssignLastMeetingInvitados() {
      if (this.lastMeeting) {
        this.selectedInvitados = this.lastMeeting.invitados || [];
      }
    },
    // TODO: implementar
    async getLastMeeting(){
      try {
        const response = await api.get(`/api/meeting/project/${this.projectId}/last`);
        this.lastMeeting = response.data;
        console.log("Última reunión:", this.lastMeeting);
      } catch (error) {
        console.error("Error al obtener la última reunión:", error);
      }
    }
  },
  mounted() {
    this.autoAssignLastMeetingInvitados();

    // Asignar todos los miembros como invitados
    this.selectedInvitados = this.project.userMembers || [];

    // Asignar el primer miembro como anfitrión y secretario si existen
    if (this.project.userMembers && this.project.userMembers.length > 0) {
      this.selectedAnfitrion = this.project.userMembers[0];
      this.selectedSecretario = this.project.userMembers[0];
    }
  },
};
</script>
